import React from 'react';
import PropTypes from 'prop-types';

import { faHourglassClock } from '@fortawesome/pro-solid-svg-icons';

import classNames from 'classnames';
import Icon from './icon';

export default function Assignees({ approvalWorkflow, tasks }) {
  const stepCount = approvalWorkflow.steps.length;
  const stepIndex = tasks[0].stepIndex;
  const anyGroup = approvalWorkflow.steps[stepIndex].mode === 'or_condition';
  let groupId = null;

  return (
    <div className="d-flex">
      <Icon className="pending bg-harvest-gold-400" icon={faHourglassClock} />
      <div className="ms-2">
        <b className="text-nowrap">Pending approval by</b>
        {tasks.map((task, i) => {
          let showOr = false;
          if (groupId !== task.groupUuid) {
            groupId = task.groupUuid;
            showOr = i > 0 && anyGroup;
          }
          return (
            <React.Fragment key={`${task.groupUuid}-${i}`}>
              {showOr && <b>or</b>}
              <div className={classNames({ 'mt-2': !showOr })} key={i}>
                {task.roles && task.roles.length > 0 && `${task.roles.join(', ')}: `}
                {join(task.assignees.map(assignee => assignee.name))}
              </div>
            </React.Fragment>
          );
        })}
        {stepCount > 1 && <b>(Step {stepIndex + 1} of {stepCount})</b>}
      </div>
    </div>
  );
}

Assignees.propTypes = {
  approvalWorkflow: PropTypes.shape({
    steps: PropTypes.array.isRequired,
  }).isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape({
    assignees: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    roles: PropTypes.arrayOf(PropTypes.string),
    stepIndex: PropTypes.number.isRequired,
  })).isRequired,
};

function join(strings) {
  if (strings.length === 1) {
    return strings[0];
  } else if (strings.length === 2) {
    return strings.join(' or ');
  } else {
    const last = strings[strings.length - 1];
    return `${strings.slice(0, strings.length - 1).join(', ')}, or ${last}`;
  }
}
